import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Modal } from 'react-bootstrap-v5'
import axios from 'axios'
import { useMutation } from '@apollo/client'

import mutations from '../../../setup/graphql/mutations'
import { getIntegrationURLFromENV, getStoredEnv } from '../../../utils/getIntegrationURLFromENV'
import { setCompanyVerificationMethod, setOpenVerification, setSubStep } from './redux/actions'
import { CompanyProfile } from '../../../svg/CompanyProfileIcon'
import { BankIcon } from '../../../svg/BankIIcon'
import { TileIcon } from '../../../svg/TileIcon'

interface Props {
  show: boolean
  handleClose: any
  goToStep: any
}

const UserVerification: FC<Props> = ({ show, handleClose, goToStep }: any) => {
  const dispatch = useDispatch()
  const history: any = useHistory()

  const coapplicant = useSelector((state: any) => state.coApplicant.co_applicant)
  const companyVerificationMethod = useSelector(
    (state: any) => state.coApplicant.companyVerificationMethod
  )

  const [updateShareholderKyc] = useMutation(mutations.UPDATE_SHAREHOLDER_KYC)

  const selectCompanyVerificationMethod = (method: number) => {
    dispatch(setCompanyVerificationMethod(method))
  }

  const connectMyInfo = async () => {
    localStorage.setItem('loanType', 'co-applicant')
    const useNewAPI = process.env.REACT_APP_USE_NEW_MYINFO_API === 'true'

    // localStorage.setItem('coApplicationId', coapplicant?.id);
    localStorage.setItem('singpass', 'myinfo')

    if (useNewAPI) {
      const env = getStoredEnv()
      const integrationUrl = getIntegrationURLFromENV(env)
      const { data } = await axios.get(
        `${integrationUrl}myinfo/login?redirect_uri=${window.location.origin}/callback`
      )
      const { authorizeUrl, state, nonce, codeVerifier } = data as any

      await updateShareholderKyc({
        variables: {
          where: { id: coapplicant?.id },
          data: {
            metadata: {
              ...((coapplicant as any)?.metadata || {}),
              myInfoLogin: { state, nonce, codeVerifier },
            },
          },
        },
      })
      ;(window as any).location = authorizeUrl
      return
    }

    // const singPassUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:3002' : 'https://iris-dev.credilinq.ai/api/alexi-singpass';
    const singPassUrl = process.env.REACT_APP_SINGPASS_URL || 'http://localhost:3002'

    // For Netrust Configuration
    // /**
    //  * Generate Netrust Code Challenge
    //  */

    // const code = await axios
    //   .get(singPassUrl + '/singpass/myinfo/generateCode')
    //   .then((response) => response.data)

    // localStorage.setItem('SINGPASS_SESSION_ID', code?.session_id ?? '')

    const getEnv = await axios.get(singPassUrl + '/getEnvMyInfo').then((response) => response.data)

    const state = Math.floor(Math.random() * 100000)
    const { clientId, redirectUrl, attributes, purpose, authApiUrl } = getEnv

    // For Netrust Integration
    // For V3
    // const authoriseUrl: any = `${authApiUrl}?client_id=${clientId}&attributes=${attributes}&purpose=${purpose}&state=${encodeURIComponent(
    //   state
    // )}&redirect_uri=${redirectUrl}&response_type=code&code_challenge_method=S256&code_challenge=${
    //   code?.code_challenge
    // }`

    // For V4
    // const authoriseUrl: any = `${authApiUrl}?client_id=${clientId}&redirect_uri=${redirectUrl}&response_type=code&code_challenge_method=S256&purpose_id=${purpose}&scope=${
    //   attributes?.split(',')?.join('+') || ''
    // }&code_challenge=${encodeURIComponent(code?.code_challenge)}`

    // For Without Netrust Integration
    const authoriseUrl: any = `${authApiUrl}?client_id=${clientId}&attributes=${attributes}&purpose=${purpose}&state=${encodeURIComponent(
      state
    )}&redirect_uri=${redirectUrl}`

    ;(window as any).location = authoriseUrl
  }

  const submitProfileVerification = () => {
    localStorage.setItem('coApplicationId', coapplicant?.id)
    if (companyVerificationMethod === 1) {
      connectMyInfo()
    } else {
      dispatch(setSubStep(3))
      history.replace(`/co-applicant/${coapplicant.id}?subStep=3`)
    }
    handleClose()
  }

  return (
    <>
      <Modal
        className='bg-transparent'
        id='kt_mega_menu_modal'
        data-backdrop='static'
        aria-hidden='true'
        role='dialog'
        tabIndex='-1'
        contentClassName='shadow-none'
        show={show}
        centered // Bootstrap's built-in class for centering modals
      >
        <div className='modal-content'>
          <div className='d-flex flex-column align-items-center justify-content-center pt-6'>
            <CompanyProfile className='mb-4' />
            <h2 className='section-heading m-0 mt-4'>Verify User Profile</h2>
            <p className='text-muted fs-6'>
              Please select how you would like to verify your user profile
            </p>
          </div>

          <div className='d-block mx-5 my-10'>
            <div className='d-flex align-items-center border-bottom  min-h-145px'>
              <div className='fv-row fv-plugins-icon-container'>
                <div className='row'>
                  <div className='col-lg-12 loan-application '>
                    <label
                      className={`btn btn-outline btn-outline-dashed btn-outline-default p-4 d-flex align-items-center mb-10 verify-profile ${
                        companyVerificationMethod === 1 ? 'verify-profile-click' : ''
                      }`}
                      htmlFor='kt_create_account_form_account_type_personal'
                      onClick={() => selectCompanyVerificationMethod(1)}
                    >
                      {/* <KTSVG
                        path='/media/icons/duotune/communication/com005.svg'
                        className='svg-icon-3x me-5'
                      /> */}

                      {/* <span className='text-dark fw-bolder d-block fs-4 mb-2'>MyInfo Business with Singpass</span> */}
                      <BankIcon />
                      <span className='d-block fw-bold text-start ms-4'>
                        <span className='text-primary fw-bold d-block fs-2 mb-2'>
                          MyInfo with SingPass
                        </span>
                        <span className='text-color-10  fs-6'>Takes about 1-2 minutes</span>
                      </span>
                    </label>
                  </div>

                  <div className='col-lg-12 loan-application '>
                    <label
                      className={`btn btn-outline btn-outline-dashed btn-outline-default p-4 d-flex align-items-center verify-profile-manual ${
                        companyVerificationMethod === 2 ? 'selected_manual' : ''
                      }`}
                      htmlFor='kt_create_account_form_account_type_corporate'
                      onClick={() => selectCompanyVerificationMethod(2)}
                    >
                      <TileIcon />

                      <span className='d-block fw-bold text-start ms-4'>
                        <span className='text-dark fw-bold d-block fs-2 mb-2'>
                          Fill out details Manually
                        </span>
                        <span className='text-gray-400 fs-6'>Takes about 5-10 minutes</span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='d-flex flex-column gap-5 flex-center mx-5 my-10'>
            <button
              className='button button-primary  w-100'
              onClick={() => submitProfileVerification()}
            >
              Verify
            </button>
            <div className='line d-flex justify-content-center text-muted'>
              <span className='zIndex-1'>OR</span>
            </div>
            <button
              className='button button-outline-back w-100'
              onClick={() => {
                dispatch(setSubStep(1))
                dispatch(setCompanyVerificationMethod(1))
                dispatch(setOpenVerification(false))
              }}
            >
              Back
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default UserVerification
